/* RESPONSIBLE TEAM: team-proactive-support */
import { attr } from '@ember-data/model';
import Fragment from 'ember-data-model-fragments/fragment';
import { validationTypes } from 'embercom/models/data/survey/constants';

export default class QuestionValidation extends Fragment {
  @attr('number', { defaultValue: () => validationTypes.text }) declare type: number;
}
